/**
 * Which viewer a `timeseries` document opens in.
 *
 * The display name is not a reliable discriminator: a connector names its
 * document "<source> — <label>" with no extension, while the stored original
 * is a JSON blob. Keying off the name alone sent those to the PDF viewer
 * ("Invalid PDF structure"). The stored path (`location`) is the truth, so it
 * is checked first, with the name's extension kept as a fallback for rows
 * that carry no location.
 */
type TimeseriesDoc = {
  name?: string | null
  location?: string | null
  properties?: { db_path?: string | null } | null
}

const endsWithJson = (path?: string | null): boolean => !!path && path.toLowerCase().endsWith('.json')

/** `/datasheet` for a spreadsheet with a SQLite db, `/timeseries` for a JSON
 *  file, otherwise `null` (the caller falls back to the document viewer). */
export function timeseriesViewerPath(doc: TimeseriesDoc & { id: string }): string | null {
  if (doc.properties?.db_path) return `/datasheet/${doc.id}`
  if (endsWithJson(doc.location) || endsWithJson(doc.name)) return `/timeseries/${doc.id}`
  return null
}
